jQuery(function($){
  const selectors = {
       section_step: '.section_step',
       start_btn_js: '.start_btn_js',
       opening_page: '.opening-page',
       multistep_Form: '.multistep_Form',
       result_Page : '.result_Page ',
       progress_bar:    '.progress_bar',
       progress_bar_text:    '.progress_bar_text',
       q1_options: '.q1_options',
       q2_options: '.q2_options',
       next_btn: '.next_btn',
       prev_btn: '.prev_btn',
       go_back:   ".go_back",
       submit_data_btn: '.submit_data_btn',
       product_item: '.product_item',
  }

  var animating;


    function change_text(){
         let step =  $(selectors.section_step+'.active').data('step');
         let total_steps = $(selectors.section_step).length;
      
         if(step <= 1){
           $(selectors.go_back).addClass('hide');
         }else{
           $(selectors.go_back).removeClass('hide');
           
         }

        let progress = ((step - 1)/total_steps) * 100;
            if(step <= 1 ){ progress = 0; }
            console.log(step);
            console.log(progress);
            
      $(selectors.progress_bar).css("width", `${progress}%` );
      $(selectors.progress_bar_text).html(`${parseInt(progress)}%`);

       $('.which_question').text(`${step} / ${total_steps}`);

      
    }



     // Events

    $(selectors.start_btn_js).on('click',function(evt){
     
         $(selectors.multistep_Form).removeClass('hide');
         $(selectors.opening_page).addClass('hide');
         $(selectors.section_step+'[data-step="1"]').addClass('active');
        
      
    });

    $(selectors.q1_options).on('click', 'input[name="q1"]',function(evt){
          $(selectors.q1_options).removeClass('radio-checked');
          $(this).parents(selectors.q1_options).addClass('radio-checked');
          $(this).parents(selectors.section_step).find(selectors.next_btn).removeAttr('disabled');
    });

   $(selectors.q2_options).on('click', 'input[name="q2"]',function(evt){
          $('.radio-d2' ,selectors.q2_options).removeClass('radio-checked1');
          $(this).parents(selectors.q2_options).find('.radio-d2').addClass('radio-checked1');
          $(this).parents(selectors.section_step).find(selectors.next_btn).removeAttr('disabled');

         let products = $('input[name="q2"]:checked').data('product');
         $(selectors.product_item).addClass('hide');
         if(products.length > 0){
                products.forEach(function(product){
                       $(`[data-pid="${product}"]`).removeClass('hide');
                          
                   });
         }
      
    });



    $(selectors.next_btn).on('click',function(evt){
           evt.preventDefault();
           if(animating) return false;
	          animating = true;
            var current_st = $(selectors.section_step+'.active');
            var next_st = current_st.next();

            let step =  current_st.data('step');
            let total_steps = $(selectors.section_step).length;
            setTimeout(function() {
               animating = false
            }, 500);
            if(step > 0 && step < total_steps ){
                    
                   $(selectors.section_step).removeClass('active');
                   next_st.addClass('active');
              }
           change_text();
           
    });


        $(selectors.prev_btn).on('click',function(evt){ 
           evt.preventDefault();
           if(animating) return false;
	          animating = true;
            var current_st = $(selectors.section_step+'.active');
            var next_st = current_st.prev();
          
            let step =  current_st.data('step') - 1;
            let total_steps = $(selectors.section_step).length;
             setTimeout(function() {
               animating = false
             }, 500);
             if(step <= 0 ){ 
               return true; 
            
            }
            
            if(step > 0 && step < total_steps ){
                    
                   $(selectors.section_step).removeClass('active');
                   next_st.addClass('active');
   
              }

          change_text();
    });

  const validateEmail = (email) => {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
};

  function submit_data(){
      let name = $('.submit_data input[name="name"]').val();
      let email = $('.submit_data input[name="email"]').val();

     if(name != '' && validateEmail(email) ){
         $(selectors.submit_data_btn).removeAttr('disabled');
     }else{
        $(selectors.submit_data_btn).attr('disabled', 'disabled');
     }
       
  }

   $('.submit_data').on('input', 'input[name="name"], input[name="email"]', function(){
       submit_data();     
   });

   $(selectors.submit_data_btn).on('click', function(evt){
         evt.preventDefault();
     var name = $('.submit_data input[name="name"]').val();
     var email = $('.submit_data input[name="email"]').val();
     if(name != '' && validateEmail(email) ){
          var settings = { 
          "async": true, 
          "crossDomain": true, 
          "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
          "method": "POST", 
          "headers": { 
            "content-type": "application/x-www-form-urlencoded", 
            "cache-control": "no-cache" 
          }, 
         "data": {
           "g": "Xr2EFY", 
           "email": email, 
            // pass in additional fields 
           "$fields": "$source, $first_name",
           "$source": "Product Quiz", 
           "$first_name": name,
           "$last_name": "",
          }
      }; 
      $.ajax(settings).done(function(response) { 

          $(selectors.multistep_Form).addClass('hide');
         $(selectors.result_Page).removeClass('hide');
          
      })

     }
   });

   $('.no_thank_you').on('click', function(evt){
      evt.preventDefault();
      $(selectors.multistep_Form).addClass('hide');
      $(selectors.result_Page).removeClass('hide');
     
   });


   $(selectors.result_Page).on('click', '.ADDTOCART_ajax ' ,function(evt){
      evt.preventDefault();
      var this_ = $(this);
      var vid = this_.data('vid');
      var available = this_.data('available');
      if(available && vid != ''){
        this_.attr('disabled', 'disabled');
        $.ajax({
                url: "/cart/add.js",
                type: "POST",
                data: {
                    items: [{
                        quantity: 1,
                        id: vid
                    }]
                },
                dataType: "json"
            })
            .done(function() {
                this_.find('.addtocart_text').text('Added');
            })
            .always(function() {
                 this_.attr('disabled', 'disabled');
                 
            });

        
      }
   });
  
  
});